<template>
  <div>
    <Table :columns="columns" :data="data">
      <template slot="action" slot-scope="{ row, index }">
        <Dropdown transfer @on-click="option(row,$event)">
          <a href="javascript:void(0)">
            <Icon type="ios-more" size="20" />
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="preview">预览</DropdownItem>
            <DropdownItem name="download">下载</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </template>
    </Table>

    <preview-file ref="perviewFile" />

  </div>
</template>

<script>
import fileImage from '@/components/common/fileImage/fileImage.vue'
export default {
  props: {
    defaultList: {
      type: Array | String
    }
  },
  data() {
    return {
      onlineWordModal: false,
      onlineFileUrl: '',
      isImage: false,
      data: [],
      columns: [
        {
          title: '类型',
          key: 'attachment',
          width: 60,
          render: (h, params) => {
            return h(fileImage, {
              attrs: {
                mediaType: params.row.attachment ? params.row.attachment.mediaType : '',
                fileName: params.row.attachment ? params.row.attachment.fileName : '',
                size: '24'
              }
            })
          }
        },
        {
          title: '文件名',
          key: 'name',
          render: (h, params) => {
            return h('span', {
              class: 'textover',
              attrs: {
                title: params.row.name
              }
            }, params.row.name)
          }
        },
        {
          title: '操作',
          slot: 'action'
        }
      ]
    }
  },

  mounted() {
    if (this.defaultList && this.defaultList.length != 0) {
      this.data = this.defaultList
    }
  },

  methods: {
    option(item, name) {
      switch (name) {
        case 'preview':
          this.$refs.perviewFile.preview(item.attachment)
          break
        case 'download':
          const url = item.attachment.url
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.target = '_blank'
          link.setAttribute('download', item.attachment.fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/view/actionPlan/plugins/checkFile.vue